import React from 'react';

interface InputCardProps {
  title: string;
  description?: string;
  isSelected: boolean;
  onClick: () => void;
  variant?: 'treatment' | 'patient';
  icon?: React.ReactNode;
}

export const InputCard = ({ 
  title,
  description,
  isSelected, 
  onClick, 
  variant = 'treatment',
  icon 
}: InputCardProps) => {
  
  const variantStyles = {
    treatment: {
      selected: 'border-teamcare-blue ring-2 ring-teamcare-blue/20 bg-teamcare-blue/5',
      unselected: 'border-gray-200 hover:border-teamcare-blue/50 hover:bg-gray-50',
      iconBg: isSelected ? 'bg-teamcare-blue/10' : 'bg-gray-100'
    },
    patient: {
      selected: 'border-teamcare-yellow ring-2 ring-teamcare-yellow/20 bg-teamcare-yellow/5',
      unselected: 'border-gray-200 hover:border-teamcare-yellow/50 hover:bg-gray-50',
      iconBg: isSelected ? 'bg-teamcare-yellow/10' : 'bg-gray-100'
    }
  };

  const currentVariant = variantStyles[variant];
  const stateClass = isSelected ? currentVariant.selected : currentVariant.unselected;

  if (variant === 'treatment') {
    return (
      <button
        onClick={onClick}
        className={`bg-white shadow-sm p-4 rounded-lg border text-black transition-all duration-200 ${stateClass}`}
      >
        <div className="flex items-center gap-4">
          {icon && (
            <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${currentVariant.iconBg}`}>
              {icon}
            </div>
          )}
          <div className="text-left flex-1">
            <div className="font-semibold text-base">{title}</div>
            {description && (
              <div className="text-sm text-gray-500 mt-1">{description}</div>
            )}
          </div>
        </div>
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`bg-white shadow-sm p-6 rounded-lg border text-black transition-all duration-200 ${stateClass}`}
    >
      <div className="flex flex-col items-center text-center gap-3">
        {icon && (
          <div className={`w-14 h-14 rounded-full flex items-center justify-center ${currentVariant.iconBg}`}>
            {icon}
          </div>
        )}
        <div>
          <div className="font-semibold text-base">{title}</div>
          {description && (
            <div className="text-sm text-gray-500 mt-1">{description}</div>
          )}
        </div>
      </div>
    </button>
  );
};